import * as React from "react";

import { HeroImage } from "components/shared/StorefrontWizard/HeroImage/HeroImage";
import { TabbedWizardCard } from "components/shared/StorefrontWizard/TabbedWizardCard/TabbedWizardCard";
import { LobQueryRouterAndCustomerNotifications } from "components/shared/StorefrontWizard/LobQueryRouterAndCustomerNotifications/LobQueryRouterAndCustomerNotifications";
import { WizardHeroProps } from "components/shared/StorefrontWizard/WizardHero/WizardHero";

export interface WizardWithHeroImageProps extends WizardHeroProps {}

export const WizardWithHeroImage: React.FC<WizardWithHeroImageProps> = ({
  isStorefrontPage,
  wizardLOBs,
  wizardFormChildren,
  trackOnChangeTab,
  context,
  heroImageFigureClassNames,
  heroImageSrc,
  isSingleLobWithTitle,
  wizardState,
  cardClass,
}) => (
  <HeroImage className={heroImageFigureClassNames} src={heroImageSrc} alt="" context={context}>
    <LobQueryRouterAndCustomerNotifications
      customerNotificationsClassName="all-x-padding-six all-t-padding-twelve"
      isStorefrontPage={isStorefrontPage}
      wizardLOBs={wizardLOBs}
    />

    <TabbedWizardCard
      context={context}
      wizardFormChildren={wizardFormChildren}
      wizardState={wizardState}
      wrappingClassNames="all-t-padding-twelve all-x-padding-six SimpleContainer"
      cardClassNames={cardClass}
      cardContentClassNames={`uitk-cell lobFormInCard ${isSingleLobWithTitle ? "all-t-padding-three" : ""}`}
      tabGroupClassNames="formAlignedTabs all-x-padding-six"
      wizardFormClassNames="wizardOverHeroImage all-x-padding-six"
      trackOnChangeTab={trackOnChangeTab}
    />
  </HeroImage>
);
